import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { SegmentedButtonStyles, applySegmentedButtonCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-segmented-button',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxSegmentedButtonStyleDirective {
  componentStyle = input<{
    style: SegmentedButtonStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applySegmentedButtonCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts()
      )
      this.styleClassName.set(className)
    })
  }
}
